import { render, staticRenderFns } from "./applyWithDral.vue?vue&type=template&id=2c654b04&scoped=true&"
import script from "./applyWithDral.vue?vue&type=script&lang=js&"
export * from "./applyWithDral.vue?vue&type=script&lang=js&"
import style0 from "./applyWithDral.vue?vue&type=style&index=0&id=2c654b04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c654b04",
  null
  
)

export default component.exports